import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/dist/vuetify.js'
Vue.use(Vuetify)

import { VueReCaptcha } from 'vue-recaptcha-v3'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueReCaptcha, {
  siteKey: '6Ldgh8UZAAAAAAMmQParFAD3SEzaiykrRP1CMiBX'

})



import VueMoment from 'vue-moment'
Vue.use(VueMoment)

import store from './store'
import './assets/custom.scss'

new Vue({
  store,
  vuetify : new Vuetify( {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
  } ),
  el: '#app',
  render: h => h(App)
})
